module.exports = __webpack_public_path__ + "static/img/first4.262ff3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/first4.png
// module id = 7I14
// module chunks = 25